import { caaMetricsRepositoryAdapter } from '../../infra/repositories/caaMetricsRepositoryAdapter'

export function GetOperationalCAAMetricsPatientSemesterCase(
  repository: ReturnType<typeof caaMetricsRepositoryAdapter>
) {
  return async (params: {
    personaName?: string
    period: number
    year: number
  }) => {
    return await repository.getOperationalCAAMetricsPatientSemester(params)
  }
}
